import { render, staticRenderFns } from "./JVxeSelectCell.vue?vue&type=template&id=9b2d187e&scoped=true"
import script from "./JVxeSelectCell.vue?vue&type=script&lang=js"
export * from "./JVxeSelectCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2d187e",
  null
  
)

export default component.exports